const Mutations = Object.freeze({
	SET_ITEM: 'gridsModule/gridsPageEdit/SET_ITEM',
	SET_RECORD: 'gridsModule/gridsPageEdit/SET_RECORD',
});
export const Actions = Object.freeze({
	CLEAR: 'gridsModule/gridsPageEdit/CLEAR',
	LOAD: 'gridsModule/gridsPageEdit/LOAD',
	LOAD_LINK_FIELD_VALUES: 'gridsModule/gridsPageEdit/LOAD_LINK_FIELD_VALUES',
	LOAD_REFERENCE_LIST_VALUES:
		'gridsModule/gridsPageEdit/LOAD_REFERENCE_LIST_VALUES',
	LOAD_RECORD: 'gridsModule/gridsPageEdit/LOAD_RECORD',
	LOAD_ITEM: 'gridsModule/gridsPageEdit/LOAD_ITEM',
	UPDATE: 'gridsModule/gridsPageEdit/UPDATE',
	UPDATE_RECORD_KEY: 'gridsModule/gridsPageEdit/UPDATE_RECORD_KEY',
	UPDATE_ITEM_KEY: 'gridsModule/gridsPageEdit/UPDATE_ITEM_KEY',
	REMOVE_RECORD_KEY: 'gridsModule/gridsPageEdit/REMOVE_RECORD_KEY',
	REMOVE_ITEM_KEY: 'gridsModule/gridsPageEdit/REMOVE_ITEM_KEY',
	BULK_EDIT: 'gridsModule/gridsPageEdit/BULK_EDIT',
});
export const Getters = Object.freeze({
	ITEM: 'gridsModule/gridsPageEdit/ITEM',
	RECORD: 'gridsModule/gridsPageEdit/RECORD',
});
import dataService from '../../../../../services/data/projectGridsService';
import { processEnum } from '../../../../../enums/processEnum';
import { GeneralActions } from '../../../../actions';
export default {
	state: {
		item: {},
		record: {},
	},
	mutations: {
		[Mutations.SET_ITEM](state, item) {
			state.item = item;
		},
		[Mutations.SET_RECORD](state, item) {
			state.record = item;
		},
	},
	actions: {
		[Actions.CLEAR]({ commit }) {
			return new Promise((resolve) => {
				commit(Mutations.SET_ITEM, {});
				commit(Mutations.SET_RECORD, {});
				resolve();
			});
		},
		[Actions.LOAD_LINK_FIELD_VALUES]({ dispatch }, item) {
			return new Promise((resolve) => {
				dataService
					.loadData(item)
					.then((resp) => {
						resolve(resp.data);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					});
			});
		},
		[Actions.LOAD_REFERENCE_LIST_VALUES]({ dispatch }) {
			return new Promise((resolve) => {
				dataService
					.getReferenceListValues()
					.then((resp) => {
						resolve(resp);
					})
					.catch((error) => {
						dispatch(GeneralActions.Error, error);
						resolve(false);
					});
			});
		},
		[Actions.LOAD](
			{ commit, dispatch },
			{ recordId, selectedEntity, gridViewId }
		) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				Promise.all([
					dataService
						.getGridRecord(recordId, selectedEntity)
						.then((resp) => {
							commit(Mutations.SET_RECORD, resp.data);
						}),
					dataService
						.loadDataById(gridViewId, recordId)
						.then((resp) => {
							commit(Mutations.SET_ITEM, resp.data);
						}),
				])
					.then(() => {
						dispatch(GeneralActions.LOADING, false);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},

		[Actions.UPDATE]({ dispatch, state }, selectedEntity) {
			return new Promise((resolve, reject) => {
				dispatch(GeneralActions.LOADING, true);
				let item = state.record;
				let formData = new FormData();
				let itemModel = {};
				Object.keys(item).forEach((key) => {
					if (key.includes('FileUdf') && item[key]) {
						formData.append(key, item[key]);
					} else {
						itemModel[key] = item[key];
					}
				});

				if (Object.keys(itemModel).length) {
					formData.append('item', JSON.stringify(itemModel));
				}
				if (JSON.stringify(item) == '{}') {
					dispatch(GeneralActions.LOADING, false);
					reject(false);
				} else {
					if (item.Id) {
						dataService
							.putGridAsset(
								formData,
								selectedEntity,
								processEnum.EditGrid
							)
							.then(() => {
								dispatch(GeneralActions.LOADING, false);
								resolve(true);
							})
							.catch((error) => {
								dispatch(GeneralActions.ERROR, error);
								dispatch(GeneralActions.LOADING, false);
							});
					} else {
						dataService
							.postGridAsset(
								formData,
								selectedEntity,
								processEnum.EditGrid
							)
							.then(() => {
								dispatch(GeneralActions.LOADING, false);
								resolve(true);
							})
							.catch((error) => {
								dispatch(GeneralActions.ERROR, error);
								dispatch(GeneralActions.LOADING, false);
							});
					}
				}
			});
		},
		[Actions.BULK_EDIT]({ dispatch }, payload) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.bulkEdit(payload)
					.then(() => {
						resolve(true);
					})
					.catch((error) => dispatch(GeneralActions.ERROR, error))
					.finally(() => dispatch(GeneralActions.LOADING, false));
			});
		},
		[Actions.UPDATE_ITEM_KEY](
			{ dispatch, commit, state },
			{ itemKey, value }
		) {
			dispatch(GeneralActions.LOADING, true);
			let item = Object.assign({}, state.item);
			item[itemKey] = value;
			commit(Mutations.SET_ITEM, item);
			dispatch(GeneralActions.LOADING, false);
		},
		[Actions.UPDATE_RECORD_KEY](
			{ dispatch, commit, state },
			{ recordKey, value }
		) {
			dispatch(GeneralActions.LOADING, true);
			let record = Object.assign({}, state.record);
			record[recordKey] = value;
			commit(Mutations.SET_RECORD, record);
			dispatch(GeneralActions.LOADING, false);
		},
		[Actions.REMOVE_ITEM_KEY]({ dispatch, commit, state }, itemKey) {
			dispatch(GeneralActions.LOADING, true);
			let item = Object.assign({}, state.item);
			delete item[itemKey];
			commit(Mutations.SET_ITEM, item);
			dispatch(GeneralActions.LOADING, false);
		},
		[Actions.REMOVE_RECORD_KEY]({ dispatch, commit, state }, recordKey) {
			dispatch(GeneralActions.LOADING, true);
			let record = Object.assign({}, state.record);
			delete record[recordKey];
			commit(Mutations.SET_RECORD, record);
			dispatch(GeneralActions.LOADING, false);
		},
	},
	getters: {
		[Getters.ITEM]: (state) => {
			if (!state.item) return {};
			return JSON.parse(JSON.stringify(state.item));
		},
		[Getters.RECORD]: (state) => {
			if (!state.record) return {};
			return JSON.parse(JSON.stringify(state.record));
		},
	},
};
